var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.61444 5.62611C3.65444 7.67 5.33 9.34556 7.37389 10.3856L8.96278 8.79667C9.165 8.59444 9.44667 8.53667 9.69944 8.61611C10.5083 8.88333 11.375 9.02778 12.2778 9.02778C12.675 9.02778 13 9.35278 13 9.75V12.2778C13 12.675 12.675 13 12.2778 13C5.49611 13 0 7.50389 0 0.722222C0 0.325 0.325 0 0.722222 0H3.25C3.64722 0 3.97222 0.325 3.97222 0.722222C3.97222 1.625 4.11667 2.49167 4.38389 3.30056C4.46333 3.55333 4.40556 3.835 4.20333 4.03722L2.61444 5.62611Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneTwo);
export default __webpack_public_path__ + "static/media/PhoneTwo.eccfbcbbe5fabc3b325785232b8df87f.svg";
export { ForwardRef as ReactComponent };